import { Component, ViewChild } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Apps } from 'src/app/models/interfaces.model';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { catchError, throwError } from 'rxjs';
import { EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { environment } from 'src/app/environments/environments';

@Component({
  selector: 'app-modal-apps',
  templateUrl: './modal-apps.component.html',
  styleUrls: ['./modal-apps.component.css']
})
export class ModalAppsComponent {
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;
  appsForm: FormGroup;
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter();
  modalTitle: string | null = null;
  appsName: string | null = null;
  appLogo: string | null = null;
  active: number = 1;
  loading: boolean = false;
  edit: number = 0;
  id: number = -1;
  archivo: File | null = null;
  AllCompanies: any;
  AssociateCompany: boolean = false;
  selectedCompanies: any;
  CompaniesApps: any[] = [];
  ALLCOMPANYAPPS: any[] = [];
  preselectedCompanyIDs: string[] = [];


  constructor(
    private fb: FormBuilder,
    public modalRef: MdbModalRef<ModalAppsComponent>,
    private crudService: GenericCrudService<Apps>) {
    this.appsForm = this.fb.group({
      appsName: ['', [Validators.required, Validators.minLength(5)]],
      active: [false],
      selectedCompanies: [null, this.validateSelectedCompanies],
    });
  }

  validateSelectedCompanies(control: FormControl) {
    const selectedOptions = control.value;
    return selectedOptions && selectedOptions.length > 0 ? null : { required: true };
  }

  ngOnInit() {
    this.appsForm.patchValue({
      appsName: this.appsName,
      appLogo: this.appLogo,
      active: this.active * 1,
    });

    this.appsForm.addControl('selectedCompanies', new FormControl());

    if (this.edit == 1) {

      this.preselectCompanies();
    }
  }

  preselectCompanies() {
    // Verificar si CompaniesApps está definido y si tiene la propiedad ID_APP
    if (this.CompaniesApps && 'ID_APP' in this.CompaniesApps) {
        // Obtener el ID_APP de CompaniesApps
        const companyID: any = this.CompaniesApps.ID_APP;

        // Filtrar todas las empresas en ALLCOMPANYAPPS que tengan el ID_APP igual al de CompaniesApps
        const selectedCompanies: any[] = this.ALLCOMPANYAPPS.filter(company => {
            return company.APPS.some((app: { ID_APP: any; }) => app.ID_APP === companyID);
        });

        // Obtener los valores "ID" de las empresas seleccionadas
        this.preselectedCompanyIDs = selectedCompanies.map(company => company.ID);

        // Establecer los valores seleccionados en el formulario
        this.appsForm.get('selectedCompanies')?.setValue(this.preselectedCompanyIDs);
    } else {
        console.error('CompaniesApps no está definido o no tiene la propiedad ID_APP');
    }
}

  InsertOrUpdate(): void {
    this.loading = true;

    const body = new FormData();
    body.append('action', this.edit == 0 ? "INSERT" : "UPDATE");
    body.append('table_name', "APPS");
    body.append('name', this.appsForm.value.appsName);

    if (this.archivo !== null) {
      body.append('applogo', this.archivo);
    }

    if (this.active !== null) {
      body.append('active', this.appsForm.value.active == 1 ? "1" : "0");
    }
    if (this.edit !== 0) {
      body.append('id', this.id.toString());
    }
    body.append('companies', this.appsForm.value.selectedCompanies.toString());


    this.loading = true;

    this.crudService.crud(body, environment.CompanyApps).pipe(
      catchError(error => {
        console.error(error);
        ShowInfoSwal(0, 'Error', error.message);
        this.loading = false;
        return throwError(error);
      })
    ).subscribe((data: any) => {

      ShowInfoSwal(data.status, data.msg, '');
      this.OnGuardarClicked.emit(true);
      this.modalRef.close();
      this.loading = false;
    });
  }

  onCheckboxChange(event: any) {
    const isChecked = event.target.checked;
    this.active = isChecked ? 1 : 0;
  }

  onFileRemoved(): void {
    this.archivo = null;
  }

  onFileAdded(files: File[]): void {
    this.archivo = files[0];
  }
}
